/**
 * @generated SignedSource<<9016225237aef86f83736fe71b89e45c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoteLockCode_Booking$data = {
  readonly remoteLockAccessCode: string | null | undefined;
  readonly startSlot: {
    readonly course?: {
      readonly remoteLockId: string | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "RemoteLockCode_Booking";
};
export type RemoteLockCode_Booking$key = {
  readonly " $data"?: RemoteLockCode_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"RemoteLockCode_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoteLockCode_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remoteLockAccessCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "remoteLockId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "2372f8f86d682c20b31e20108b0253c3";

export default node;
